import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cx } from './cx'
import './button.css'

export type ButtonVariant = 'primary' | 'secondary' | 'ghost'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  /** The larger call-to-action size used on the landing and onboarding screens. */
  size?: 'md' | 'lg'
  /** Full width, for stacked forms. */
  block?: boolean
  children?: ReactNode
}

export function Button({
  variant = 'secondary',
  size = 'md',
  block = false,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      // Defaulting to type="button" matters: a bare <button> inside a form submits it, and
      // several of these sit beside inputs.
      type={type}
      className={cx(
        'btn',
        `btn-${variant}`,
        size === 'lg' && 'btn-lg',
        block && 'btn-block',
        className,
      )}
      {...rest}
    />
  )
}
